<template>
  <span>
    <b-badge v-if="sample_count" pill :variant="variant">
      {{ percent }}%
    </b-badge>
    <b-badge pill v-else variant="">
      N/A
    </b-badge>
  </span>
</template>

<script>
  export default {
    name: "ProjectProgressBadge",
    props: [
      "project",
      "status_name"
    ],
    data() {
      return {
        sample_count: null,
        percent: null,
        variant: null,
      }
    },
    methods: {

      getSampleCount() {
        if(this.sample_count !== null) {
          return this.sample_count;
        }
        let count = 0;
        this.project.getSubmissions().models.forEach((submission) => {
          submission.getSamples().models.forEach(() => {
            count++;
          });
        });
        return count;
      },

      getSampleStatusPercentage() {
        if(this.percent !== null) {
          return this.percent;
        }
        let status_name = this.status_name;
        let count = 0;
        this.project.getSubmissions().models.forEach(((submission) => {
          submission.getSamples().models.forEach((sample) => {
            let exists = false;
            sample.getSampleStatusLogs().models.forEach((log) => {
              let status = log.getSampleStatus();
              if(status && status.status === status_name) {
                exists = true;
              }
            });
            if(exists) {
              count++;
            }
          });
        }));
        return Math.ceil(count / +(this.sample_count) * 100);
      },

      getSampleStatusVariant() {
        let percent = this.percent;
        if(percent >= 100) {
          return 'success';
        } else if(percent > 0) {
          return 'warning';
        } else {
          return 'danger';
        }
      },

    },
    watch: {
      'project.submissions': {
        handler() {
          this.sample_count = this.getSampleCount();
          this.percent = this.getSampleStatusPercentage();
          this.variant = this.getSampleStatusVariant();
        },
        immediate: true
      }
    }
  }

</script>
